<template>
    <v-menu
        rounded="0"
        :nudge-width="450"
        :close-on-content-click="false"
        offset-y
    >
        <template v-slot:activator="{ attrs, on }">
            <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                :loading="bellLoading"
            >
                <v-badge
                    :content="numberOfNotifications"
                    :value="numberOfNotifications"
                    color="red"
                    overlap
                >
                    <v-icon>mdi-bell</v-icon>
                </v-badge>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Notifications
                <v-spacer />
                <v-btn icon to="/notifications/config">
                    <v-icon>mdi-cogs</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text v-if="!numberOfNotifications">
                    No notification yet
            </v-card-text>
            <v-list v-else>
                <v-list-item v-for="notification in unreadNotifications" :key="notification.id" @click="open(notification)">
                    <v-list-item-content>
                        <v-list-item-title v-text="notification.data.title" />
                        <v-list-item-subtitle
                            class="text--primary"
                            v-text="notification.data.message"
                        />
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-list-item-action-text>{{ timeago(notification.created_at) }} </v-list-item-action-text>
                        <v-icon>
                            mdi-eye
                        </v-icon>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
            <v-pagination v-model="currentPage" :length="pages"/>
                    
            <v-card-actions>
                <v-btn x-small text @click="markAllAsRead" :loading="loading">Mark all as read</v-btn>
                <v-spacer />
                <v-btn to="/notifications">View all notification</v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
export default {
    data: () => ({
        interval:null,
        timerState: "Start",
        currentPage:1
    }),
    computed:{
        ...mapGetters('notifications', ['unreadNotifications', 'bellLoading', 'loading', 'total', 'pages']),
        numberOfNotifications(){
            return this.total
        }
    },
    watch: {
        currentPage(){
            this.doTimerAction()
        }
    },
    mounted() {
        this.interval = setInterval(() => {
            this.doTimerAction();
        }, 10000);
        this.doTimerAction();
        window.onfocus = this.startTimer
        window.onblur = this.pauseTimer
    },
    methods: {
        ...mapActions('notifications', {
            fetchNotification : 'unread',
            markAsRead: 'markAsRead',
            markAllAsRead: 'markAllAsRead'
        }),
        doTimerAction () {
            if(this.timerState == "Start") {
                this.fetchNotification({page:this.currentPage})
            }
        },
        startTimer () {
            this.timerState = "Start"
        },
        pauseTimer () {
            this.timerState = "Pause"
        },
        timeago(date){
            return moment(date).fromNow()
        },
        open(notification){
            this.markAsRead(notification.id);
            this.$router.push(notification.data.url)
        }
    },
    destroyed(){
        clearInterval(this.interval)
        this.timerState = "Stop"
    }
}
</script>

<style>

</style>